import Image from 'next/image';
import { type FC } from 'react';

import classes from './HelpCenterCard.module.scss';

type HelpCenterCardProps = {
  onClick?: () => void;
};

const HelpCenterCard: FC<HelpCenterCardProps> = ({ onClick }) => {
  const handleKeyDown = (event: React.KeyboardEvent): void => {
    if (onClick && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <div className={classes.wrapper}>
      <div
        className={classes.card}
        onClick={onClick}
        onKeyDown={handleKeyDown}
        role='button'
        tabIndex={0}
        aria-label='AI powered Help Center'
      >
        <div className={classes.iconContainer}>
          <Image
            width={32}
            height={32}
            src='/glade-help-center-icon.png'
            alt='Glade Help Center'
            className={classes.icon}
          />
        </div>
        <div className={classes.content}>
          <p className={`${classes.title} ai-label`}>AI powered Help Center</p>
          <p className={classes.description}>Access Immediate product support & how-to resources.</p>
        </div>
      </div>
    </div>
  );
};

export default HelpCenterCard;
